export const GUARANTEE_CONSTANTS = {
  headline: 'Your Happiness is Our Happiness',
  subheadline: `If you aren't 100% thrilled with your purchase, return it within 4 months for a full refund, no questions asked. Plus, if your device experiences a covered issue within the first 3 years, we'll replace it free of charge; that's our 3-year limited warranty.`,
  shortSubheadline: `If you aren't 100% thrilled with your purchase, return it for a full refund. No questions asked.`,
  returns: '4-Month Free Returns',
  happiness: `Your happiness is our happiness. If you aren't 100% thrilled with your purchase, return it for a full refund. No questions asked.`,
}
